import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CountryValueEnum } from '../../../shared/models/country-value.enum';
import { OrganismeService } from '../../../organisme/services/organisme.service';
import { Utilisateur } from '../../../utilisateur/models/utilisateur';
import { Credit } from '../../models/credit';
import { CreditService } from '../../services/credit.service';

@Component({
  selector: 'app-commande-credits-online-container',
  templateUrl: './commande-credits-online.container.html',
  styleUrls: ['./commande-credits-online.container.scss'],
})
export class CommandeCreditsOnlineContainer implements OnInit {
  packs: Credit.Pack[] = [];

  commande!: Credit.Commande;
  currentEtape: Credit.EtapeCommande = Credit.EtapeCommande.MA_COMMANDE;
  etapeCommandeEnum = Credit.EtapeCommande;
  loading = false;
  isCB = false;
  isAutoliquidation = false;

  constructor(
    private readonly creditService: CreditService,
    private readonly organismeService: OrganismeService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    const [packs, organisme] = await Promise.all([
      this.creditService.getAllPacks(),
      this.organismeService.getOrganismeBilling(),
    ]);
    this.packs = packs;
    this.isCB = organisme?.billing?.type?.toUpperCase() === Utilisateur.Type.CB;
    this.isAutoliquidation =
      organisme?.billing?.countryCode?.toUpperCase() === CountryValueEnum.UE &&
      !organisme?.billing?.tvaIntracommunautaire;
  }

  onPackSelected(pack: Credit.Pack): void {
    this.packs.forEach((p) => {
      p.selected = p.id === pack.id;
    });

    this.commande = { ...this.commande, pack };

    if (pack?.isSpecialPack) {
      this.commande.isRenouvellementAuto = false;
    }
  }

  onRenouvellementAutoSet(isRenouvellementAuto: boolean): void {
    this.commande = { ...this.commande, isRenouvellementAuto };
  }

  onCommander(): void {
    this.currentEtape = Credit.EtapeCommande.MES_INFORMATIONS_ADMINISTRATIVES;
  }

  onPayer(): void {
    this.router.navigate(
      ['/commander-credits-en-ligne/recapitulatif', this.commande.pack!.id],
      {
        queryParams: {
          renouvellement: this.commande.isRenouvellementAuto ?? false,
        },
      },
    );
  }

  onPrecedent(): void {
    this.currentEtape = Credit.EtapeCommande.MA_COMMANDE;
  }

  async onValiderCommande(): Promise<void> {
    this.loading = true;
    this.commande = await this.creditService.commander(this.commande);
    this.currentEtape = Credit.EtapeCommande.MA_VALIDATION;
    this.loading = false;
  }
}
